/**
 * Numbered section heading in the report style: "1. Services".
 * `number` is optional; `level` picks h2 (default) or h3.
 */
export default function SectionHeading({ number, children, level = 2, id, className = '' }) {
  const Tag = level === 3 ? 'h3' : 'h2'

  return (
    <Tag
      id={id}
      className={`border-b-2 border-ink pb-2 font-serif text-2xl font-bold text-ink sm:text-3xl ${className}`}
    >
      {number != null && <span className="mr-2 font-mono text-signal">{number}.</span>}
      {children}
    </Tag>
  )
}
